import { useEffect, useState } from "react";

import { getKbNodeFile } from "@/shared/api/knowledge";

type Source = { url?: string; type?: string; file?: File; error?: string };

/** The stored bytes as an object URL (and as a File, for the viewer that draws Office files),
    revoked when `enabled` flips off or the file closes. */
export function useObjectUrl(kbId: string, nodeId: string, enabled: boolean, name = ""): Source & { loading: boolean } {
  const [source, setSource] = useState<Source & { key?: string }>({});
  const key = `${kbId}/${nodeId}`;

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    let url: string | undefined;
    getKbNodeFile(kbId, nodeId).then(
      (blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setSource({ key, url, type: blob.type, file: new File([blob], name, { type: blob.type }) });
      },
      (e: Error) => !cancelled && setSource({ key, error: e.message }),
    );
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
      setSource({});
    };
  }, [kbId, nodeId, key, enabled, name]);

  const ready = source.key === key;
  return { url: ready ? source.url : undefined, type: ready ? source.type : undefined, file: ready ? source.file : undefined, error: ready ? source.error : undefined, loading: enabled && !ready };
}
